import _defineProperty from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { WINDOW } from '@sentry/browser';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx"; // We need to disable eslint no-explict-any because any is required for the
// react-router typings.

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-enable @typescript-eslint/no-explicit-any */

var activeTransaction;

function reactRouterV4Instrumentation(history, routes, matchPath) {
  return createReactRouterInstrumentation(history, 'react-router-v4', routes, matchPath);
}

function reactRouterV5Instrumentation(history, routes, matchPath) {
  return createReactRouterInstrumentation(history, 'react-router-v5', routes, matchPath);
}

function createReactRouterInstrumentation(history, name) {
  var allRoutes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var matchPath = arguments.length > 3 ? arguments[3] : undefined;

  function getInitPathName() {
    if (history && history.location) {
      return history.location.pathname;
    }

    if (WINDOW && WINDOW.location) {
      return WINDOW.location.pathname;
    }

    return undefined;
  }
  /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */


  function normalizeTransactionName(pathname) {
    if (allRoutes.length === 0 || !matchPath) {
      return [pathname, 'url'];
    }

    var branches = matchRoutes(allRoutes, pathname, matchPath); // eslint-disable-next-line @typescript-eslint/prefer-for-of

    for (var x = 0; x < branches.length; x++) {
      if (branches[x].match.isExact) {
        return [branches[x].match.path, 'route'];
      }
    }

    return [pathname, 'url'];
  }

  var tags = {
    'routing.instrumentation': name
  };
  return function (customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var initPathName = getInitPathName();

    if (startTransactionOnPageLoad && initPathName) {
      var _normalizeTransaction = normalizeTransactionName(initPathName),
          _normalizeTransaction2 = _slicedToArray(_normalizeTransaction, 2),
          _name = _normalizeTransaction2[0],
          source = _normalizeTransaction2[1];

      activeTransaction = customStartTransaction({
        name: _name,
        op: 'pageload',
        tags: tags,
        metadata: {
          source: source
        }
      });
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen(function (location, action) {
        if (action && (action === 'PUSH' || action === 'POP')) {
          if (activeTransaction) {
            activeTransaction.finish();
          }

          var _normalizeTransaction3 = normalizeTransactionName(location.pathname),
              _normalizeTransaction4 = _slicedToArray(_normalizeTransaction3, 2),
              _name2 = _normalizeTransaction4[0],
              _source = _normalizeTransaction4[1];

          activeTransaction = customStartTransaction({
            name: _name2,
            op: 'navigation',
            tags: tags,
            metadata: {
              source: _source
            }
          });
        }
      });
    }
  };
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */


function matchRoutes(routes, pathname, matchPath) {
  var branch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  routes.some(function (route) {
    var match = route.path ? matchPath(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
    : computeRootMatch(pathname); // use default "root" match

    if (match) {
      branch.push({
        route: route,
        match: match
      });

      if (route.routes) {
        matchRoutes(route.routes, pathname, matchPath, branch);
      }
    }

    return !!match;
  });
  return branch;
}

function computeRootMatch(pathname) {
  return {
    path: '/',
    url: '/',
    params: {},
    isExact: pathname === '/'
  };
}
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */


function withSentryRouting(Route) {
  var _this = this;

  var componentDisplayName = Route.displayName || Route.name;

  var WrappedRoute = function WrappedRoute(props) {
    if (activeTransaction && props && props.computedMatch && props.computedMatch.isExact) {
      activeTransaction.setName(props.computedMatch.path, 'route');
    } // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164


    return React.createElement(Route, _objectSpread(_objectSpread({}, props), {}, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174
      }
    }));
  };

  WrappedRoute.displayName = "sentryRoute(".concat(componentDisplayName, ")");
  hoistNonReactStatics(WrappedRoute, Route); // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params:
  // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164

  return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */


export { reactRouterV4Instrumentation, reactRouterV5Instrumentation, withSentryRouting };